














































































import { defineComponent, ref } from "@nuxtjs/composition-api";
import { filter, isEmpty, map, startsWith } from "lodash-es";
import { useGtm } from "~/composables";

import MenuSubList from './MenuSubList.vue';
export default defineComponent({
  name: "MenuItemSub",
  components: {
    MenuSubList
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    menu: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
  },
  setup(props) {
    const { eventCustomlinksInteracted } = useGtm();
    const subCat1 = ref([]);
    const subCat2 = ref([]);
    const activeItemKey = ref(null);
    const showChildMenu = function (key) {
      activeItemKey.value = key;
    };

    if (props.menu.url_key === "products-applications") {
      subCat1.value = filter(
        props.menu.children,
        (item) => !isEmpty(item.children)
      );
      subCat2.value = filter(props.menu.children, (item) =>
        isEmpty(item.children)
      );
    } else {
      const subMenu = map(props.menu.children, (item) => {
        item.children = [];
        return item;
      });
      subCat1.value = filter(subMenu, (item) => !isEmpty(item.children));
      subCat2.value = filter(subMenu, (item) => isEmpty(item.children));
    }

    const navigationTracking = (menu) => {
      eventCustomlinksInteracted({
        "eventlabel": menu.title,
        "eventCategory": "Primary Navigation Links",
      });
    };

    return {
      subCat1,
      subCat2,
      showChildMenu,
      activeItemKey,
      navigationTracking,
      startsWith,
      httpText: 'https://',
    };
  },
});
